import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ResourcePlanDetailsModalState,
  AdditionalInformation,
} from "@src/types";

const initialState: ResourcePlanDetailsModalState = {
  resourcePlanModalVisible: false,
  selectedResourcePlanRequestId: null,
  currentTab: "0",
  selectedStandardRoleId: null,
  jointVenture: null,
  additionalInformation: null,
};

const roleRequestDetailsModalSlice = createSlice({
  name: "resourcePlanDetailsModal",
  initialState: initialState,
  reducers: {
    /**
     * Set the current selected standard role
     *
     * @param state
     * @param modalVisible
     */
    setSelectedStandardRoleId: (
      state: ResourcePlanDetailsModalState,
      modalVisible: PayloadAction<any>
    ) => {
      state.selectedStandardRoleId = modalVisible.payload;
    },

    /**
     * Set the visibility of the resource plan details modal
     *
     * @param state
     * @param modalVisible
     */
    setResourcePlanDetailsModalVisibility: (
      state: ResourcePlanDetailsModalState,
      modalVisible: PayloadAction<boolean>
    ) => {
      state.resourcePlanModalVisible = modalVisible.payload;
    },

    /**
     * Set the selected resource plan request id
     *
     * @param state
     * @param selectedRoleRequestId
     */
    setSelectedResourcePlanRequestId: (
      state: ResourcePlanDetailsModalState,
      selectedRoleRequestId: PayloadAction<number>
    ) => {
      state.selectedResourcePlanRequestId = selectedRoleRequestId.payload;
    },

    /**
     * Set the current tab
     *
     * @param state
     * @param currentSelectedTab
     */
    setCurrentResourcePlanRequestDetailTab: (
      state: ResourcePlanDetailsModalState,
      currentSelectedTab: PayloadAction<string>
    ) => {
      state.currentTab = currentSelectedTab.payload;
    },

    /**
     * Add the updated additional information fields like scope, project identifier or specific role
     *
     * @param state
     * @param additionalInformation
     */
    setAdditionalInformation: (
      state: ResourcePlanDetailsModalState,
      additionalInformation: PayloadAction<AdditionalInformation>
    ) => {
      state.additionalInformation = additionalInformation.payload;
    },

    /**
     * Will set the request to joint venture or remove the joint venture flag
     *
     * @param state
     * @param jointVenture
     */
    setJointVenture: (
      state: ResourcePlanDetailsModalState,
      jointVenture: PayloadAction<boolean>
    ) => {
      state.jointVenture = jointVenture.payload;
    },

    clearResourcePlanModal: () => initialState,
  },
});

export const {
  setSelectedStandardRoleId,
  setResourcePlanDetailsModalVisibility,
  setSelectedResourcePlanRequestId,
  setCurrentResourcePlanRequestDetailTab,
  setAdditionalInformation,
  setJointVenture,

  clearResourcePlanModal,
} = roleRequestDetailsModalSlice.actions;

export default roleRequestDetailsModalSlice;
